'use strict';

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _HtmlUtils = require('../../../HtmlUtils');

var HtmlUtils = _interopRequireWildcard(_HtmlUtils);

var _DateUtils = require('../../../DateUtils');

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _Modal = require('../../../Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _dispatcher = require('../../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _languageHandler = require('../../../languageHandler');

var _ContextualMenu = require('../../structures/ContextualMenu');

var ContextualMenu = _interopRequireWildcard(_ContextualMenu);

var _SettingsStore = require('../../../settings/SettingsStore');

var _SettingsStore2 = _interopRequireDefault(_SettingsStore);

var _ReplyThread = require('../elements/ReplyThread');

var _ReplyThread2 = _interopRequireDefault(_ReplyThread);

var _Permalinks = require('../../../utils/permalinks/Permalinks');

var _LocalStorage = require('../../../utils/LocalStorage');

var _LocalStorage2 = _interopRequireDefault(_LocalStorage);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2015, 2016 OpenMarket Ltd
Copyright 2017 New Vector Ltd
Copyright 2019 The Matrix.org Foundation C.I.C.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var classNames = require("classnames");


module.exports = (0, _createReactClass2.default)({
    displayName: 'TextualBody',

    propTypes: {
        /* the MatrixEvent to show */
        mxEvent: _propTypes2.default.object.isRequired,

        /* a list of words to highlight */
        highlights: _propTypes2.default.array,

        /* link URL for the highlights */
        highlightLink: _propTypes2.default.string,

        /* should show URL previews for this event */
        showUrlPreview: _propTypes2.default.bool,

        /* callback for when our widget has loaded */
        onHeightChanged: _propTypes2.default.func,

        /* the shape of the tile, used */
        tileShape: _propTypes2.default.string,

        /* true if this is a continuation of the previous event (which has the
         * effect of not showing another avatar/displayname
         */
        continuation: _propTypes2.default.bool,

        messageOverlayPosition: _propTypes2.default.string
    },

    getInitialState: function getInitialState() {
        return {
            // the URLs (if any) to be previewed with a LinkPreviewWidget
            // inside this TextualBody.
            links: [],

            // track whether the preview widget is hidden
            widgetHidden: false
        };
    },

    copyToClipboard: function copyToClipboard(text) {
        var textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();

        var successful = false;
        try {
            successful = document.execCommand('copy');
        } catch (err) {
            console.log('Unable to copy');
        }

        document.body.removeChild(textArea);
        return successful;
    },

    componentDidMount: function componentDidMount() {
        this._unmounted = false;
        this._applyFormatting();
    },

    _applyFormatting: function _applyFormatting() {
        HtmlUtils.linkifyElement(this.refs.content);
        this.calculateUrlPreview();
    },


    componentWillUnmount: function componentWillUnmount() {
        this._unmounted = true;
    },

    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        //console.info("shouldComponentUpdate: ShowUrlPreview for %s is %s", this.props.mxEvent.getId(), this.props.showUrlPreview);

        // exploit that events are immutable :)
        return nextProps.mxEvent.getId() !== this.props.mxEvent.getId() || nextProps.highlights !== this.props.highlights || nextProps.replacingEventId !== this.props.replacingEventId || nextProps.highlightLink !== this.props.highlightLink || nextProps.showUrlPreview !== this.props.showUrlPreview || nextState.links !== this.state.links || nextState.widgetHidden !== this.state.widgetHidden;
    },

    calculateUrlPreview: function calculateUrlPreview() {
        //console.info("calculateUrlPreview: ShowUrlPreview for %s is %s", this.props.mxEvent.getId(), this.props.showUrlPreview);

        if (this.props.showUrlPreview) {
            var links = this.findLinks(this.refs.content.children);
            if (links.length) {
                // de-dup the links (but preserve ordering)
                var seen = new _set2.default();
                links = links.filter(function (link) {
                    if (seen.has(link)) return false;
                    seen.add(link);
                    return true;
                });

                this.setState({ links: links });

                // lazy-load the hidden state of the preview widget from localstorage
                if (_LocalStorage2.default) {
                    var hidden = _LocalStorage2.default.getItem("hide_preview_" + this.props.mxEvent.getId());
                    this.setState({ widgetHidden: hidden });
                }
            }
        }
    },

    findLinks: function findLinks(nodes) {
        var links = [];

        for (var i = 0; i < nodes.length; i++) {
            var node = nodes[i];
            if (node.tagName === "A" && node.getAttribute("href")) {
                if (this.isLinkPreviewable(node)) {
                    links.push(node.getAttribute("href"));
                }
            } else if (node.tagName === "PRE" || node.tagName === "CODE" || node.tagName === "BLOCKQUOTE") {
                continue;
            } else if (node.children && node.children.length) {
                links = links.concat(this.findLinks(node.children));
            }
        }
        return links;
    },

    isLinkPreviewable: function isLinkPreviewable(node) {
        // don't try to preview relative links
        if (!node.getAttribute("href").startsWith("http://") && !node.getAttribute("href").startsWith("https://")) {
            return false;
        }

        // as a random heuristic to avoid highlighting things like "foo.pl"
        // we require the linked text to either include a / (either from http://
        // or from a full foo.bar/baz style schemeless URL) - or be a markdown-style
        // link, in which case we check the target text differs from the link value.
        // TODO: make this configurable?
        if (node.textContent.indexOf("/") > -1) {
            return true;
        } else {
            var url = node.getAttribute("href");
            var host = url.match(/^https?:\/\/(.*?)(\/|$)/)[1];

            // never preview permalinks (if anything we should give a smart
            // preview of the room/user they point to: nobody needs to be reminded
            // what the matrix.to site looks like).
            if ((0, _Permalinks.isPermalinkHost)(host)) return false;

            if (node.textContent.toLowerCase().trim().startsWith(host.toLowerCase())) {
                // it's a "foo.pl" style link
                return false;
            } else {
                // it's a [foo bar](http://foo.com) style link
                return true;
            }
        }
    },

    onCancelClick: function onCancelClick(event) {
        this.setState({ widgetHidden: true });
        // FIXME: persist this somewhere smarter than local storage
        if (_LocalStorage2.default) {
            _LocalStorage2.default.setItem("hide_preview_" + this.props.mxEvent.getId(), "1");
        }
        this.forceUpdate();
    },

    onEmoteSenderClick: function onEmoteSenderClick(event) {
        var mxEvent = this.props.mxEvent;
        _dispatcher2.default.dispatch({
            action: 'insert_mention',
            user_id: mxEvent.getSender()
        });
    },

    getEventTileOps: function getEventTileOps() {
        var _this = this;

        return {
            isWidgetHidden: function isWidgetHidden() {
                return _this.state.widgetHidden;
            },

            unhideWidget: function unhideWidget() {
                _this.setState({ widgetHidden: false });
                if (_LocalStorage2.default) {
                    _LocalStorage2.default.removeItem("hide_preview_" + _this.props.mxEvent.getId());
                }
            },

            getInnerText: function getInnerText() {
                return _this.refs.content.innerText;
            }
        };
    },

    onStarterLinkClick: function onStarterLinkClick(starterLink, ev) {
        return;
    },

    render: function render() {
        var _this2 = this;

        var mxEvent = this.props.mxEvent;
        var content = mxEvent.getContent();

        var stripReply = _ReplyThread2.default.getParentEventId(mxEvent);
        var body = HtmlUtils.bodyToHtml(content, this.props.highlights, {
            disableBigEmoji: content.msgtype === "m.emote" || !_SettingsStore2.default.getValue('TextualBody.enableBigEmoji'),
            // Part of Replies fallback support
            stripReplyFallback: stripReply
        });

        if (this.props.highlightLink) {
            body = _react2.default.createElement(
                'a',
                { href: this.props.highlightLink },
                body
            );
        } else if (content.data && typeof content.data["org.matrix.neb.starter_link"] === "string") {
            body = _react2.default.createElement(
                'a',
                { href: '#', onClick: this.onStarterLinkClick.bind(this, content.data["org.matrix.neb.starter_link"]) },
                body
            );
        }

        var widgets = void 0;
        if (this.state.links.length && !this.state.widgetHidden && this.props.showUrlPreview) {
            var LinkPreviewWidget = _index2.default.getComponent('rooms.LinkPreviewWidget');
            widgets = this.state.links.map(function (link) {
                return _react2.default.createElement(LinkPreviewWidget, {
                    key: link,
                    link: link,
                    mxEvent: _this2.props.mxEvent,
                    onCancelClick: _this2.onCancelClick,
                    onHeightChanged: _this2.props.onHeightChanged });
            });
        }

        var MessageOverlay = _index2.default.getComponent('messages.MessageOverlay');
        var messageOverlay = this.props.messageOverlayPosition === 'content' ? _react2.default.createElement(MessageOverlay, {
            mxEvent: this.props.mxEvent,
            tileShape: this.props.tileShape,
            continuation: this.props.continuation,
            permalinkCreator: this.props.permalinkCreator
        }) : undefined;

        switch (content.msgtype) {
            case "m.emote":
                var name = mxEvent.sender ? mxEvent.sender.name : mxEvent.getSender();
                return _react2.default.createElement(
                    'span',
                    { ref: 'content', className: classNames("mx_MEmoteBody mx_EventTile_content", { mx_EventTile_withReplyThread: stripReply }) },
                    '*\xA0',
                    _react2.default.createElement(
                        'span',
                        {
                            className: 'mx_MEmoteBody_sender',
                            onClick: this.onEmoteSenderClick
                        },
                        name
                    ),
                    '\xA0',
                    body,
                    widgets,
                    messageOverlay
                );
            case "m.notice":
                return _react2.default.createElement(
                    'span',
                    { ref: 'content', className: classNames("mx_MNoticeBody mx_EventTile_content", { mx_EventTile_withReplyThread: stripReply }) },
                    body,
                    widgets,
                    messageOverlay
                );
            default:
                // including "m.text"
                return _react2.default.createElement(
                    'span',
                    { ref: 'content', className: classNames("mx_MTextBody mx_EventTile_content", { mx_EventTile_withReplyThread: stripReply }) },
                    body,
                    widgets,
                    messageOverlay
                );
        }
    }
});
//# sourceMappingURL=TextualBody.js.map